import { Box, SxProps } from '@mui/material';
import { colors } from '../constants/colors';

const classes = {
  root: {
    width: '18px',
    height: '18px',
    minWidth: '18px',
    minHeight: '18px',
    backgroundColor: colors.green,
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
};

export interface ICheckCircleIconProps {
  sx?: SxProps;
}

export const CheckCircleIcon = ({ sx = {} }: ICheckCircleIconProps) => {
  return (
    <Box sx={{ ...classes.root, ...sx }}>
      <svg
        width="9"
        height="7"
        viewBox="0 0 9 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1L3.1875 6L1 3.72727"
          stroke={colors.white}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};
